"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPaginatedFindMyCombosResponseList = instanceOfPaginatedFindMyCombosResponseList;
exports.PaginatedFindMyCombosResponseListFromJSON = PaginatedFindMyCombosResponseListFromJSON;
exports.PaginatedFindMyCombosResponseListFromJSONTyped = PaginatedFindMyCombosResponseListFromJSONTyped;
exports.PaginatedFindMyCombosResponseListToJSON = PaginatedFindMyCombosResponseListToJSON;
exports.PaginatedFindMyCombosResponseListToJSONTyped = PaginatedFindMyCombosResponseListToJSONTyped;
const paginatedFindMyCombosResponseListResults_1 = require("./paginatedFindMyCombosResponseListResults");
/**
 * Check if a given object implements the PaginatedFindMyCombosResponseList interface.
 */
function instanceOfPaginatedFindMyCombosResponseList(value) {
    if (!('count' in value) || value['count'] === undefined)
        return false;
    if (!('next' in value) || value['next'] === undefined)
        return false;
    if (!('previous' in value) || value['previous'] === undefined)
        return false;
    if (!('results' in value) || value['results'] === undefined)
        return false;
    return true;
}
function PaginatedFindMyCombosResponseListFromJSON(json) {
    return PaginatedFindMyCombosResponseListFromJSONTyped(json, false);
}
function PaginatedFindMyCombosResponseListFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'count': json['count'],
        'next': json['next'],
        'previous': json['previous'],
        'results': (0, paginatedFindMyCombosResponseListResults_1.PaginatedFindMyCombosResponseListResultsFromJSON)(json['results']),
    };
}
function PaginatedFindMyCombosResponseListToJSON(json) {
    return PaginatedFindMyCombosResponseListToJSONTyped(json, false);
}
function PaginatedFindMyCombosResponseListToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': (0, paginatedFindMyCombosResponseListResults_1.PaginatedFindMyCombosResponseListResultsToJSON)(value['results']),
    };
}
//# sourceMappingURL=paginatedFindMyCombosResponseList.js.map